import { useTheme } from '@mui/material';

import gasOptimizedByDesignIcon from '../../../public/svg/icons/whyRF/gasOptimizedByDesign.svg';
import postLaunchSupportIcon from '../../../public/svg/icons/whyRF/postLaunchSupport.svg';
import securityFirstMethodologyIcon from '../../../public/svg/icons/whyRF/securityFirstMethodology.svg';
import weActuallyShipProductionCodeIcon from '../../../public/svg/icons/whyRF/weActuallyShipProductionCode.svg';

export const WhyRFData = () => {
  const theme = useTheme();
  return [
    {
      name: 'we_actually_ship_production_code',
      icon: weActuallyShipProductionCodeIcon,
      title: 'We Actually Ship Production Code',
      boxShadow: theme.mixins.orangeGradientTransparent?.boxShadow || '',
      duration: 4,
      floatingY: 7.4,
      description:
        'We build smart contracts that handle millions in real value. Our code runs on mainnet, not just testnets.',
    },
    {
      name: 'security_first_methodology',
      icon: securityFirstMethodologyIcon,
      title: 'Security-First Methodology',
      boxShadow: theme.mixins.redGradientTransparent?.boxShadow || '',
      duration: 5,
      floatingY: 6.8,
      description:
        'Every contract goes through rigorous internal auditing, formal verification, and stress testing.',
    },
    {
      name: 'gas_optimized_by_design',
      icon: gasOptimizedByDesignIcon,
      title: 'Gas-Optimized by Design',
      boxShadow: theme.mixins.greenGradientTransparent?.boxShadow || '',
      duration: 4.5,
      floatingY: 7.2,
      description:
        "We don't just make it work; we make it efficient. Typical 40-60% gas reduction means your users can actually afford to use your dApp.",
    },
    {
      name: 'post_launch_support',
      icon: postLaunchSupportIcon,
      title: 'Post-Launch Support',
      boxShadow: theme.mixins.blueGradientTransparent?.boxShadow || '',
      duration: 4.2,
      floatingY: 6.5,
      description:
        "We don't disappear after deployment. Ongoing monitoring, optimization, and upgrades ensure your contracts perform flawlessly long-term.",
    },
  ];
};
